import { media, styled, typography } from '@pulse-web-ui/theme';

export const Wrapper = styled.div<{ $hasBackground?: boolean }>`
  padding: 24px;
  ${({ theme, $hasBackground }) =>
    !$hasBackground && `border: 1px solid ${theme.colors.neutral[30]}`};

  border-radius: ${({ theme, $hasBackground }) =>
    $hasBackground
      ? `calc(${theme.common.radius} * 6)`
      : `calc(${theme.common.radius} * 3)`};
  ${({ theme, $hasBackground }) =>
    $hasBackground && `background: ${theme.colors.surface.primary}`};
  display: flex;
  flex-direction: column;
  gap: 24px;
  align-items: flex-start;
  box-sizing: border-box;
  max-width: 768px;
`;

export const Title = styled.h4`
  ${typography.medium18}
  line-height: 24px;
  margin-bottom: 0;

  ${media.desktop} {
    ${typography.medium20}
    line-height: 28px;
  }
`;

export const Description = styled.p`
  ${typography.regular16}
  line-height: 24px;
  color: ${({ theme }) => theme.colors.text.primary};
  margin: 0;
`;

export const IconContainer = styled.span`
  margin-left: 4px;
  vertical-align: sub;
`;
